import { Component, Input, OnInit } from '@angular/core';
import { CalendarEvent } from 'src/app/models/calendar-event';

@Component({
  selector: 'app-calendar-print-list-day',
  templateUrl: './calendar-print-list-day.component.html',
  styleUrls: ['./calendar-print-list-day.component.scss'],
})
export class CalendarPrintListDayComponent implements OnInit {
  /** The day as an ISO date (2026-10-13), as the grouped events are keyed. */
  @Input()
  day: string;

  @Input()
  events: Map<string, CalendarEvent[]>;

  constructor() {}

  ngOnInit(): void {}
}
